import React from 'react';
import ReactDom from 'react-dom';
import {MenuBar} from './menuBar';
import {Search, myData} from './search';
import {Footer} from './footer';
import {BrowserRouter as Router,
    Switch,
    Route,
    useParams} from 'react-router-dom';
import {Top} from './top';
import './styling/book-info.css';

const Main = () => {
    return (<>
    <Router>
        <MenuBar/>
        <Top/>
        <Switch>
            <Route path="/" exact>
                <Search/>
                <Footer/>
            </Route>
            <Route path="/:id">
                <BookInfo/>
            </Route>
        </Switch>
    </Router>
    </>
    )
}

const BookInfo = () => {
    const { id } = useParams();
    let thisBook = myData.filter(obj => obj.id === id);
    if(thisBook.length !== 0) {
        return <>
            <div className="book-info">
                {thisBook[0].volumeInfo.imageLinks && <img src={thisBook[0].volumeInfo.imageLinks.thumbnail} alt="صورة الكتاب"></img>}
                <div className="grid">
                    {thisBook[0].volumeInfo.title && <h1>{thisBook[0].volumeInfo.title}</h1>}
                    {thisBook[0].volumeInfo.authors && <strong>{thisBook[0].volumeInfo.authors[0]}</strong>}
                    {thisBook[0].volumeInfo.publishedDate && <h2>{thisBook[0].volumeInfo.publishedDate} : تاريخ النشر</h2>}
                    {thisBook[0].volumeInfo.publisher && <h2>{thisBook[0].volumeInfo.publisher} : دار النشر</h2>}
                    {thisBook[0].volumeInfo.pageCount && <h2>{thisBook[0].volumeInfo.pageCount} : عدد الصفحات</h2>}
                    {thisBook[0].volumeInfo.categories && <h2>{thisBook[0].volumeInfo.categories[0]} : قسم الكتاب</h2>}
                    {thisBook[0].volumeInfo.description && <><h1 style={{borderBottom: "#1ba94c 3px solid"}}>وصف الكتاب</h1>
                    <p>{thisBook[0].volumeInfo.description}</p></>}
                </div>
                {thisBook[0].accessInfo.webReaderLink && <a href={thisBook[0].accessInfo.webReaderLink} target="blank">
                    <button className="read">1قراءة</button>
                    </a>}
                {thisBook[0].volumeInfo.previewLink && <>
                <a href={thisBook[0].volumeInfo.previewLink} target="blank">
                    <button  className="read">2قراءة</button>
                </a>
                </>}
            </div>
        </>
    }else {
        window.history.back();
        return <><div></div></>;
    }
}
ReactDom.render(<Main/>, document.getElementById('root'));
